import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { MediaBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { borderRadius } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderRadius";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { objectFit } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/objectFit";
import { objectPosition } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/objectPosition";
import { opacity } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/opacity";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import { sizing } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/sizing";
import {
  ContentProp,
  CornersProp,
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
  SizingProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Image",
  version: 1,
  nameI18n: "builder_ui.block_type.img",
  category: [MediaBlock],
  props: {
    image: {
      name: "Image",
      nameI18n: "builder_ui.prop_type.image.image",
      category: [ContentProp],
      prop: "other",
      type: "circle-image-upload",
    },
    alt: {
      name: "Alt text",
      nameI18n: "builder_ui.prop_type.image.alt_text",
      category: [ContentProp],
      prop: "other",
      type: "string",
    },
    href: {
      name: "Link URL",
      nameI18n: "builder_ui.prop_type.url",
      category: [ContentProp],
      prop: "other",
      type: "url",
    },
    target: {
      name: "Link target",
      nameI18n: "builder_ui.prop_type.target",
      category: [ContentProp],
      prop: "other",
      type: "select",
      options: [
        {
          label: "Self",
          labelI18n: "builder_ui.prop_type.target_types.self",
          value: "_self",
        },
        {
          label: "Blank",
          labelI18n: "builder_ui.prop_type.target_types.blank",
          value: "_blank",
        },
      ],
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles.title",
      category: [DesignProp],
      prop: "styles",
      type: "styles",
      attributes: {
        objectFit: {
          ...objectFit,
          defaultValue: defaultStyles.objectFit,
          category: [DesignProp, GeneralProp],
        },
        objectPosition: {
          ...objectPosition,
          defaultValue: defaultStyles.objectPosition,
          category: [DesignProp, GeneralProp],
        },
        opacity: {
          ...opacity,
          defaultValue: defaultStyles.opacity,
          category: [DesignProp, GeneralProp],
        },
        borderRadius: {
          ...borderRadius,
          defaultValue: defaultStyles.borderRadius,
          category: [DesignProp, CornersProp],
        },
        sizing: {
          ...sizing,
          defaultValue: defaultStyles.sizing,
          category: [DesignProp, SizingProp],
        },
        padding: {
          ...padding,
          defaultValue: defaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        },
        margin: {
          ...margin,
          defaultValue: defaultStyles.margin,
          category: [DesignProp, MarginsProp],
        },
      },
    },
  },
};
